// frontend/src/pages/PrivacyPolicy.js
import '../custom.css'
import React from 'react'
import { Container } from 'react-bootstrap'

export default function PrivacyPolicy () {
  return (
    <>
      <section className='full-bleed py-5 bg-primary-soft text-center'>
        <Container style={{ maxWidth: 960 }}>
          <h1 className='display-5 fw-bold mb-3'>Privacy&nbsp;Policy</h1>
          <p className='lead'>
            Your privacy matters. This policy explains what data we collect,
            why we collect it, and how you can manage it.
          </p>
        </Container>
      </section>

      <section className='py-5'>
        <Container style={{ maxWidth: 960 }}>
          <h3 className='fw-bold mt-4'>1.&nbsp;Who we are</h3>
          <p>
            Greatly Social (“we”, “our”, “us”) provides social-media management
            tools at <strong>greatlysocial.com</strong>. We are the data
            controller for information processed under this policy.
          </p>

          <h3 className='fw-bold mt-4'>2.&nbsp;Information we collect</h3>
          <ul>
            <li><strong>Account data</strong> – name, email, password&nbsp;(hashed).</li>
            <li><strong>Billing data</strong> – address &amp; last-4 of card (processed by Stripe).</li>
            <li><strong>Usage data</strong> – log files, device/browser, IP, pages visited.</li>
            <li><strong>Social-network tokens</strong> – OAuth tokens required to post on your behalf.</li>
            <li><strong>Cookies &amp; similar tech</strong> – to keep you logged-in and analyse traffic.</li>
          </ul>

          <h3 className='fw-bold mt-4'>3.&nbsp;How we use information</h3>
          <ul>
            <li>Provide and maintain the platform.</li>
            <li>Process payments and send invoices.</li>
            <li>Improve features and combat fraud.</li>
            <li>Send service-related messages and optional marketing (you may opt-out anytime).</li>
          </ul>

          <h3 className='fw-bold mt-4'>4.&nbsp;Legal bases</h3>
          <p>We rely on contract performance, legitimate interests, or consent where required by law.</p>

          <h3 className='fw-bold mt-4'>5.&nbsp;Sharing &amp; disclosure</h3>
          <p>
            We never sell your data. We share it only with vetted processors
            (e.g.&nbsp;Stripe, AWS, analytics providers) under strict
            confidentiality and security agreements, or if legally compelled.
          </p>

          <h3 className='fw-bold mt-4'>6.&nbsp;International transfers</h3>
          <p>Data may be stored or processed in the&nbsp;US, Canada, or the EU under appropriate safeguards (SCCs).</p>

          <h3 className='fw-bold mt-4'>7.&nbsp;Data retention</h3>
          <p>We keep data while your account is active and for up to 12 months after deletion, unless a longer period is required by law.</p>

          <h3 className='fw-bold mt-4'>8.&nbsp;Your rights</h3>
          <p>You may access, correct, delete, export, or object to processing of your personal data at any time. Email&nbsp;<a href='mailto:privacy@greatlysocial.com'>privacy@greatlysocial.com</a>.</p>

          <h3 className='fw-bold mt-4'>9.&nbsp;Children’s privacy</h3>
          <p>Our service is not directed to children under 13. We do not knowingly collect personal data from them.</p>

          <h3 className='fw-bold mt-4'>10.&nbsp;Changes to this policy</h3>
          <p>We’ll post any updates on this page and notify you of significant changes via email or in-app notice.</p>

          <h3 className='fw-bold mt-4'>11.&nbsp;Contact us</h3>
          <p>Email: <a href='mailto:privacy@greatlysocial.com'>privacy@greatlysocial.com</a></p>
        </Container>
      </section>
    </>
  )
}
